import type { IconNode } from '../types';

/**
 * @name chairs-table-parasol
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgOHYxMyIgLz4KICA8cGF0aCBkPSJNMjEgOEgzbDktNloiIC8+CiAgPHBhdGggZD0iTTcgMTNoMTAiIC8+CiAgPHBhdGggZD0iTTggMjF2LTNhMSAxIDAgMCAwLTEtMUgzIiAvPgogIDxwYXRoIGQ9Ik0zIDEydjkiIC8+CiAgPHBhdGggZD0iTTE2IDIxdi0zYzAtLjUuNS0xIDEtMWg0IiAvPgogIDxwYXRoIGQ9Ik0yMSAxMnY5IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/chairs-table-parasol
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const chairsTableParasol: IconNode = [
  ['path', { d: 'M12 8v13', key: '1c76mn' }],
  ['path', { d: 'M21 8H3l9-6Z', key: 'lj1hvn' }],
  ['path', { d: 'M7 13h10', key: '1rwob1' }],
  ['path', { d: 'M8 21v-3a1 1 0 0 0-1-1H3', key: '8ronke' }],
  ['path', { d: 'M3 12v9', key: '1ya0z6' }],
  ['path', { d: 'M16 21v-3c0-.5.5-1 1-1h4', key: '916dt4' }],
  ['path', { d: 'M21 12v9', key: '95s048' }],
];

export default chairsTableParasol;
